import type { ReceiptTemplate } from '../schema';

export const receiptJarTemplate: ReceiptTemplate = {
  id: 'receipt-jar',
  name: 'Receipt Jar Receipt',
  brand: 'RECEIPT JAR',
  description: 'Receipt Jar earnings receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'rj-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: 'RECEIPT JAR',
        businessNameFontSize: 18,
        addressLines: ['EARNINGS SUMMARY'],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'rj-scan',
      type: 'two-column',
      enabled: true,
      config: {
        alignment: 'left',
        column1: [
          { id: 'scan', label: 'Scan #:', value: 'RJ-847291034' },
          { id: 'user', label: 'User:', value: 'john@email.com' },
        ],
        column2: [
          { id: 'date', label: 'Date:', value: '01/04/2026' },
          { id: 'store', label: 'Store:', value: 'CVS' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'rj-earnings',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'base', label: 'BASE REWARD', value: '0.10', isBold: false, isLarge: false },
          { id: 'bonus', label: 'BONUS', value: '0.25', isBold: false, isLarge: false },
          { id: 'total', label: 'EARNED', value: '0.35', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'rj-balance',
      type: 'custom-message',
      enabled: true,
      config: { alignment: 'center', message: 'JAR BALANCE: $14.50\n\nKEEP EARNING!', fontSize: 12, showDivider: false, dividerStyle: 'solid', isBold: false },
    },
  ],
  updatedAt: new Date().toISOString(),
};

